<script lang="ts" setup>
import type { IconDefinition as SolidIcon } from '@fortawesome/pro-solid-svg-icons'
import type { IconDefinition as RegularIcon } from '@fortawesome/pro-regular-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import IconContainer from './IconContainer.vue'

defineOptions({
  name: 'DefaultIcon',
})

defineProps<{
  icon: SolidIcon | RegularIcon
}>()
</script>

<template>
  <IconContainer>
    <FontAwesomeIcon
      :icon="icon"
    />
  </IconContainer>
</template>

<style scoped lang="scss" src="./DefaultIcon.scss" />
